<input #videoFile type="file" accept="video/*" (change)="readVideo(videoFile.files!)"/>
<button type="button" (click)="videoFile.click()" i18n-title title="Upload or record video" i18n>🎞️</button>
